(function () {
  var WISHLIST_KEY = 'popshop:wishlist';
  var RECENT_KEY = 'popshop:recently-viewed';
  var CONSENT_KEY = 'popshop:cookie-consent';

  function readJson(key, fallback) {
    try {
      return JSON.parse(window.localStorage.getItem(key)) || fallback;
    } catch (error) {
      return fallback;
    }
  }

  function writeJson(key, value) {
    window.localStorage.setItem(key, JSON.stringify(value));
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
      }[char];
    });
  }

  function getWishlist() {
    return readJson(WISHLIST_KEY, []);
  }

  function setWishlist(items) {
    writeJson(WISHLIST_KEY, items);
    syncWishlist();
  }

  function productFromButton(button) {
    return {
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
    };
  }

  function syncWishlist() {
    var items = getWishlist();
    var handles = items.map(function (item) {
      return item.handle;
    });

    document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      var isSaved = handles.indexOf(button.dataset.productHandle) > -1;
      button.setAttribute('aria-pressed', String(isSaved));
    });

    document.querySelectorAll('[data-wishlist-count]').forEach(function (count) {
      count.textContent = String(items.length);
    });

    var list = document.querySelector('[data-wishlist-items]');
    if (!list) return;

    if (!items.length) {
      list.innerHTML = '<p class="wishlist-empty">Your wishlist is empty.</p>';
      return;
    }

    list.innerHTML = items
      .map(function (item) {
        return [
          '<article class="wishlist-item">',
          '<a class="wishlist-item__media" href="' + item.url + '">',
          item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '">' : '',
          '</a>',
          '<button type="button" class="wishlist-item__remove" data-wishlist-remove="' + escapeHtml(item.handle) + '" aria-label="Remove ' + escapeHtml(item.title) + ' from wishlist">',
          '<span class="wishlist-button__icon" aria-hidden="true"></span>',
          '</button>',
          '<div class="wishlist-item__content">',
          '<a class="wishlist-item__title" href="' + item.url + '">' + escapeHtml(item.title) + '</a>',
          '<p class="wishlist-item__price">' + escapeHtml(item.price) + '</p>',
          '</div>',
          '<a class="wishlist-item__add" href="' + item.url + '">Add to bag</a>',
          '</article>',
        ].join('');
      })
      .join('');
  }

  function initWishlist() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-wishlist-button]');
      if (button) {
        var item = productFromButton(button);
        var items = getWishlist();
        var exists = items.some(function (saved) {
          return saved.handle === item.handle;
        });

        setWishlist(exists ? items.filter(function (saved) { return saved.handle !== item.handle; }) : [item].concat(items));
      }

      var removeButton = event.target.closest('[data-wishlist-remove]');
      if (removeButton) {
        setWishlist(getWishlist().filter(function (saved) {
          return saved.handle !== removeButton.dataset.wishlistRemove;
        }));
      }

      if (event.target.closest('[data-wishlist-open]')) {
        var drawer = document.querySelector('[data-wishlist-drawer]');
        if (drawer) drawer.setAttribute('aria-hidden', 'false');
        var menuDrawer = document.querySelector('[data-menu-drawer]');
        if (menuDrawer) menuDrawer.setAttribute('aria-hidden', 'true');
        var menuButton = document.querySelector('[data-menu-toggle]');
        if (menuButton) {
          menuButton.setAttribute('aria-expanded', 'false');
          menuButton.setAttribute('aria-label', 'Open menu');
        }
      }

      if (event.target.closest('[data-wishlist-close]')) {
        var openDrawer = document.querySelector('[data-wishlist-drawer]');
        if (openDrawer) openDrawer.setAttribute('aria-hidden', 'true');
      }
    });

    syncWishlist();
  }

  function initMenuDrawer() {
    function showMenuScreen(name) {
      document.querySelectorAll('[data-menu-screen]').forEach(function (screen) {
        screen.hidden = screen.dataset.menuScreen !== name;
      });
    }

    function resetMenuScreens() {
      showMenuScreen('main');
    }

    document.addEventListener('click', function (event) {
      var drawer = document.querySelector('[data-menu-drawer]');
      var button = document.querySelector('[data-menu-toggle]');
      if (!drawer) return;

      if (event.target.closest('[data-menu-toggle]')) {
        var isOpen = drawer.getAttribute('aria-hidden') === 'false';
        drawer.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
        document.documentElement.style.overflow = isOpen ? '' : 'hidden';
        if (button) {
          button.setAttribute('aria-expanded', String(!isOpen));
          button.setAttribute('aria-label', isOpen ? 'Open menu' : 'Close menu');
        }
        if (isOpen) resetMenuScreens();
      }

      var screenTrigger = event.target.closest('[data-menu-screen-open]');
      if (screenTrigger) {
        showMenuScreen(screenTrigger.dataset.menuScreenOpen);
      }

      if (event.target.closest('[data-menu-screen-back]')) {
        resetMenuScreens();
      }

      if (event.target.closest('[data-menu-close]')) {
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        if (button) {
          button.setAttribute('aria-expanded', 'false');
          button.setAttribute('aria-label', 'Open menu');
        }
        resetMenuScreens();
      }

      if (event.target === drawer) {
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        if (button) {
          button.setAttribute('aria-expanded', 'false');
          button.setAttribute('aria-label', 'Open menu');
        }
        resetMenuScreens();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var drawer = document.querySelector('[data-menu-drawer]');
      var button = document.querySelector('[data-menu-toggle]');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (button) {
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', 'Open menu');
      }
      resetMenuScreens();
    });
  }

  function initCartDrawer() {
    function closeCartDrawer() {
      var drawer = document.querySelector('[data-cart-drawer]');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    function openCartDrawer() {
      var drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer) return;

      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';

      var menuDrawer = document.querySelector('[data-menu-drawer]');
      if (menuDrawer) menuDrawer.setAttribute('aria-hidden', 'true');

      var wishlistDrawer = document.querySelector('[data-wishlist-drawer]');
      if (wishlistDrawer) wishlistDrawer.setAttribute('aria-hidden', 'true');

      var menuButton = document.querySelector('[data-menu-toggle]');
      if (menuButton) {
        menuButton.setAttribute('aria-expanded', 'false');
        menuButton.setAttribute('aria-label', 'Open menu');
      }

      var closeButton = drawer.querySelector('[data-cart-close]');
      if (closeButton) closeButton.focus();
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-open]')) {
        event.preventDefault();
        openCartDrawer();
      }

      if (event.target.closest('[data-cart-close]')) {
        closeCartDrawer();
      }

      var drawer = document.querySelector('[data-cart-drawer]');
      if (drawer && event.target === drawer) {
        closeCartDrawer();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeCartDrawer();
    });
  }

  function initLocalization() {
    document.querySelectorAll('[data-localization-selector]').forEach(function (selector) {
      selector.addEventListener('change', function () {
        selector.closest('form').submit();
      });
    });
  }

  function initCollectionControls() {
    function closeFilterDrawer() {
      var drawer = document.querySelector('[data-filter-drawer]');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    function openFilterDrawer() {
      var drawer = document.querySelector('[data-filter-drawer]');
      if (!drawer) return;

      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';

      var closeButton = drawer.querySelector('[data-filter-drawer-close]');
      if (closeButton) closeButton.focus();
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-filter-drawer-open]')) {
        openFilterDrawer();
      }

      if (event.target.closest('[data-filter-drawer-close]')) {
        closeFilterDrawer();
      }

      var drawer = document.querySelector('[data-filter-drawer]');
      if (drawer && event.target === drawer) {
        closeFilterDrawer();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeFilterDrawer();
    });

    document.querySelectorAll('[data-collection-sort]').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  function initRecentlyViewed() {
    var currentProduct = document.querySelector('[data-recent-product]');
    if (currentProduct) {
      try {
        var product = JSON.parse(currentProduct.textContent);
        var items = readJson(RECENT_KEY, []).filter(function (item) {
          return item.handle !== product.handle;
        });
        writeJson(RECENT_KEY, [product].concat(items).slice(0, 8));
      } catch (error) {}
    }

    var grid = document.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    var currentHandle = currentProduct ? JSON.parse(currentProduct.textContent).handle : '';
    var recent = readJson(RECENT_KEY, []).filter(function (item) {
      return item.handle !== currentHandle;
    });

    if (!recent.length) {
      var section = document.querySelector('[data-recently-viewed]');
      if (section) section.hidden = true;
      return;
    }

    grid.innerHTML = recent
      .slice(0, 4)
      .map(function (item) {
        return [
          '<article class="product-card">',
          '<a class="product-card__media" href="' + item.url + '">',
          item.image ? '<img class="product-card__image" src="' + item.image + '" alt="' + escapeHtml(item.title) + '">' : '',
          '</a>',
          '<div class="product-card__content">',
          '<a class="product-card__title" href="' + item.url + '">' + escapeHtml(item.title) + '</a>',
          '<p class="product-card__price">' + escapeHtml(item.price) + '</p>',
          '</div>',
          '</article>',
        ].join('');
      })
      .join('');
  }

  function injectScript(src, onload) {
    var script = document.createElement('script');
    script.async = true;
    script.src = src;
    if (onload) script.onload = onload;
    document.head.appendChild(script);
  }

  function readProductPixelData() {
    var node = document.querySelector('[data-product-pixel]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function productPixelDataFromElement(element) {
    if (!element) return null;

    return {
      id: element.dataset.productId,
      variantId: element.dataset.productVariantId,
      title: element.dataset.productTitle,
      price: parseFloat(element.dataset.productPrice || '0'),
      currency: element.dataset.productCurrency,
      url: element.dataset.productUrl,
    };
  }

  function sendProductPixelEvent(eventName, product) {
    if (!product || window.localStorage.getItem(CONSENT_KEY) !== 'accepted') return;

    var contentId = String(product.variantId || product.id || '');
    var value = Number(product.price || 0);
    var currency = product.currency || 'USD';

    if (window.fbq && contentId) {
      window.fbq('track', eventName, {
        content_ids: [contentId],
        content_type: 'product',
        content_name: product.title || '',
        value: value,
        currency: currency,
      });
    }

    if (window.ttq && window.ttq.track && contentId) {
      window.ttq.track(eventName, {
        content_id: contentId,
        content_type: 'product',
        content_name: product.title || '',
        value: value,
        currency: currency,
      });
    }

    if (window.gtag && contentId) {
      window.gtag('event', eventName === 'ViewContent' ? 'view_item' : 'add_to_cart', {
        currency: currency,
        value: value,
        items: [
          {
            item_id: contentId,
            item_name: product.title || '',
          },
        ],
      });
    }
  }

  function trackProductView() {
    if (window.PopshopProductViewTracked) return;

    var product = readProductPixelData();
    if (!product) return;

    window.PopshopProductViewTracked = true;
    sendProductPixelEvent('ViewContent', product);
  }

  function initProductPixelEvents() {
    document.addEventListener('submit', function (event) {
      var form = event.target.closest ? event.target.closest('form') : null;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

      var product = productPixelDataFromElement(form.closest('[data-product-pixel-item]')) || readProductPixelData();
      if (!product) return;

      var variantInput = form.querySelector('[name="id"]');
      if (variantInput && variantInput.value) product.variantId = variantInput.value;

      sendProductPixelEvent('AddToCart', product);
    });
  }

  function initTracking() {
    var settingsNode = document.getElementById('PopshopTrackingSettings');
    if (!settingsNode || window.PopshopTrackingLoaded) return;
    window.PopshopTrackingLoaded = true;

    var settings = {};
    try {
      settings = JSON.parse(settingsNode.textContent);
    } catch (error) {}

    if (settings.metaPixelId) {
      window.fbq =
        window.fbq ||
        function () {
          (window.fbq.callMethod ? window.fbq.callMethod : window.fbq.queue.push).apply(window.fbq, arguments);
        };
      window.fbq.queue = window.fbq.queue || [];
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      injectScript('https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', settings.metaPixelId);
      window.fbq('track', 'PageView');
    }

    if (settings.tiktokPixelId) {
      window.ttq = window.ttq || [];
      window.ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'];
      window.ttq.setAndDefer = function (target, method) {
        target[method] = function () {
          target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      for (var i = 0; i < window.ttq.methods.length; i += 1) window.ttq.setAndDefer(window.ttq, window.ttq.methods[i]);
      window.ttq.load = function (id) {
        injectScript('https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=' + id + '&lib=ttq');
      };
      window.ttq.load(settings.tiktokPixelId);
      window.ttq.page();
    }

    if (settings.ga4MeasurementId) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      injectScript('https://www.googletagmanager.com/gtag/js?id=' + settings.ga4MeasurementId);
      window.gtag('js', new Date());
      window.gtag('config', settings.ga4MeasurementId);
    }

    trackProductView();
  }

  function initCookieConsent() {
    var banner = document.querySelector('[data-cookie-consent]');
    var consent = window.localStorage.getItem(CONSENT_KEY);

    if (consent === 'accepted') {
      initTracking();
      return;
    }

    if (!banner) return;
    if (!consent) banner.dataset.visible = 'true';

    var accept = banner.querySelector('[data-cookie-accept]');
    var decline = banner.querySelector('[data-cookie-decline]');

    if (accept) {
      accept.addEventListener('click', function () {
        window.localStorage.setItem(CONSENT_KEY, 'accepted');
        banner.dataset.visible = 'false';
        initTracking();
      });
    }

    if (decline) {
      decline.addEventListener('click', function () {
        window.localStorage.setItem(CONSENT_KEY, 'declined');
        banner.dataset.visible = 'false';
      });
    }
  }

  function initRecommendations() {
    document.querySelectorAll('[data-product-recommendations]').forEach(function (section) {
      var url = section.dataset.url;
      if (!url || section.children.length > 0) return;

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var container = document.createElement('div');
          container.innerHTML = html;
          var recommendations = container.querySelector('[data-product-recommendations]');
          if (recommendations && recommendations.innerHTML.trim().length) {
            section.innerHTML = recommendations.innerHTML;
            syncWishlist();
          }
        })
        .catch(function () {});
    });
  }

  function initProductGalleries() {
    document.querySelectorAll('.product-gallery').forEach(function (gallery) {
      var track = gallery.querySelector('.product-gallery__track');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__slide'));
      var count = gallery.querySelector('[data-product-gallery-count]');
      var prev = gallery.querySelector('[data-product-gallery-prev]');
      var next = gallery.querySelector('[data-product-gallery-next]');

      if (!track || !slides.length || !count) return;

      function visibleSlides() {
        return slides.filter(function (slide) {
          return !slide.hidden;
        });
      }

      function currentIndex() {
        var activeSlides = visibleSlides();
        if (!activeSlides.length) return 0;

        var trackLeft = track.getBoundingClientRect().left;
        var nearest = 0;
        var nearestDistance = Infinity;

        activeSlides.forEach(function (slide, index) {
          var distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          if (distance < nearestDistance) {
            nearest = index;
            nearestDistance = distance;
          }
        });

        return nearest;
      }

      function updateCount() {
        var activeSlides = visibleSlides();
        count.textContent = (activeSlides.length ? currentIndex() + 1 : 0) + '/' + activeSlides.length;
      }

      function scrollToIndex(index) {
        var activeSlides = visibleSlides();
        if (!activeSlides.length) return;

        var nextIndex = Math.max(0, Math.min(activeSlides.length - 1, index));
        track.scrollTo({
          left: activeSlides[nextIndex].offsetLeft - track.offsetLeft,
          behavior: 'smooth',
        });
      }

      function scrollToSlide(slide) {
        if (!slide || slide.hidden) return;

        track.scrollTo({
          left: slide.offsetLeft - track.offsetLeft,
          behavior: 'smooth',
        });
      }

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateCount);
      });

      if (prev) {
        prev.addEventListener('click', function () {
          scrollToIndex(currentIndex() - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          scrollToIndex(currentIndex() + 1);
        });
      }

      gallery.addEventListener('product:gallery-filtered', function (event) {
        updateCount();
        scrollToSlide(event.detail && event.detail.targetSlide);
      });

      updateCount();
    });
  }

  function initProductLightbox() {
    var lightbox = document.querySelector('[data-product-lightbox]');
    if (!lightbox) return;

    var image = lightbox.querySelector('[data-product-lightbox-image]');
    var closeControls = lightbox.querySelectorAll('[data-product-lightbox-close]');
    var prevButton = lightbox.querySelector('[data-product-lightbox-prev]');
    var nextButton = lightbox.querySelector('[data-product-lightbox-next]');
    var dots = lightbox.querySelector('[data-product-lightbox-dots]');
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-product-lightbox-open]'));
    var lastTrigger = null;
    var currentIndex = 0;
    var zoom = 1;

    function visibleTriggers() {
      var activeTriggers = triggers.filter(function (trigger) {
        var slide = trigger.closest('.product-gallery__slide');
        return !slide || !slide.hidden;
      });

      return activeTriggers.length ? activeTriggers : triggers;
    }

    function updateZoom() {
      if (!image) return;
      image.style.transform = 'scale(' + zoom + ')';
      image.style.cursor = zoom < 2.5 ? 'zoom-in' : 'zoom-out';
    }

    function setZoom(value) {
      zoom = Math.max(1, Math.min(2.5, value));
      updateZoom();
    }

    function renderDots() {
      if (!dots) return;
      var activeTriggers = visibleTriggers();
      dots.innerHTML = activeTriggers
        .map(function (_trigger, index) {
          return '<button type="button" data-product-lightbox-dot="' + index + '" aria-label="View image ' + (index + 1) + '"' + (index === currentIndex ? ' aria-current="true"' : '') + '></button>';
        })
        .join('');
    }

    function showImage(index) {
      if (!image || !triggers.length) return;
      var activeTriggers = visibleTriggers();
      currentIndex = (index + activeTriggers.length) % activeTriggers.length;
      var trigger = activeTriggers[currentIndex];
      image.src = trigger.dataset.productLightboxSrc || '';
      image.alt = trigger.dataset.productLightboxAlt || '';
      setZoom(1);
      renderDots();
    }

    function openLightbox(trigger) {
      if (!image || !trigger) return;
      lastTrigger = trigger;
      var activeTriggers = visibleTriggers();
      var requestedIndex = activeTriggers.indexOf(trigger);
      showImage(requestedIndex > -1 ? requestedIndex : 0);
      lightbox.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var closeButton = lightbox.querySelector('[data-product-lightbox-close]');
      if (closeButton) closeButton.focus();
    }

    function closeLightbox() {
      lightbox.hidden = true;
      document.documentElement.style.overflow = '';
      if (image) image.src = '';
      if (lastTrigger) lastTrigger.focus();
    }

    function goToNext() {
      showImage(currentIndex + 1);
    }

    function goToPrev() {
      showImage(currentIndex - 1);
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-product-lightbox-open]');
      if (trigger) {
        event.preventDefault();
        openLightbox(trigger);
      }
    });

    closeControls.forEach(function (control) {
      control.addEventListener('click', closeLightbox);
    });

    if (prevButton) {
      prevButton.addEventListener('click', goToPrev);
    }

    if (nextButton) {
      nextButton.addEventListener('click', goToNext);
    }

    if (dots) {
      dots.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-product-lightbox-dot]');
        if (!dot) return;
        showImage(Number(dot.dataset.productLightboxDot));
      });
    }

    if (image) {
      image.addEventListener('click', function () {
        setZoom(zoom >= 2.5 ? 1 : zoom + 0.5);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowRight') goToNext();
      if (event.key === 'ArrowLeft') goToPrev();
      if (event.key === '+' || event.key === '=') setZoom(zoom + 0.25);
      if (event.key === '-' || event.key === '_') setZoom(zoom - 0.25);
    });
  }

  function initProductOptions() {
    document.querySelectorAll('[data-product-options]').forEach(function (picker) {
      var dataNode = picker.querySelector('[data-product-variants-json]');
      var form = picker.closest('form');
      var variantInput = form ? form.querySelector('[data-product-variant-id-input]') : null;
      var submit = form ? form.querySelector('input[type="submit"], button[type="submit"]') : null;
      if (!dataNode || !variantInput) return;

      var data = {};
      try {
        data = JSON.parse(dataNode.textContent);
      } catch (error) {
        return;
      }

      var variants = data.variants || [];
      var selectedOptions = (data.selectedOptions || []).slice();
      var availableText = submit ? submit.value || submit.textContent.trim() : 'Add to cart';
      var productDetail = picker.closest('[data-product-detail]');
      var productGallery = productDetail ? productDetail.querySelector('.product-gallery') : null;
      var galleryTrack = productDetail ? productDetail.querySelector('.product-gallery__track') : null;
      var colorGroup = picker.querySelector('.product-option--color[data-product-option-group]');
      var colorOptionIndex = colorGroup ? Number(colorGroup.dataset.optionPosition) - 1 : -1;

      function normalize(value) {
        return String(value || '')
          .toLowerCase()
          .replace(/&/g, 'and')
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();
      }

      function findVariant(options) {
        return variants.find(function (variant) {
          return options.every(function (value, index) {
            return variant.options[index] === value;
          });
        });
      }

      function selectFallbackVariant(changedIndex) {
        var selectedVariant = findVariant(selectedOptions);
        if (selectedVariant && selectedVariant.available) return;

        var fallback = variants.find(function (variant) {
          return variant.available && variant.options[changedIndex] === selectedOptions[changedIndex];
        });

        if (fallback) selectedOptions = fallback.options.slice();
      }

      function hasAvailableVariant(optionIndex, value, group) {
        var isColorGroup = group && group.classList.contains('product-option--color');

        return variants.some(function (variant) {
          if (!variant.available || variant.options[optionIndex] !== value) return false;
          if (isColorGroup) return true;

          return selectedOptions.every(function (selectedValue, selectedIndex) {
            return selectedIndex === optionIndex || variant.options[selectedIndex] === selectedValue;
          });
        });
      }

      function scrollToVariantMedia(variant) {
        if (!galleryTrack || !variant || !variant.mediaId) return;

        var slide = galleryTrack.querySelector('[data-product-media-id="' + variant.mediaId + '"]');
        if (!slide) return;

        galleryTrack.scrollTo({
          left: slide.offsetLeft - galleryTrack.offsetLeft,
          behavior: 'smooth',
        });
      }

      function filterGalleryByColor(variant) {
        if (!productGallery || !galleryTrack || colorOptionIndex < 0) return;

        var color = selectedOptions[colorOptionIndex];
        var normalizedColor = normalize(color);
        var slides = Array.prototype.slice.call(galleryTrack.querySelectorAll('.product-gallery__slide'));
        var matchingSlides = normalizedColor
          ? slides.filter(function (slide) {
              return normalize(slide.dataset.productMediaAlt).indexOf(normalizedColor) !== -1;
            })
          : [];

        var shouldFilter = matchingSlides.length > 0;
        var targetSlide = null;

        slides.forEach(function (slide) {
          slide.hidden = shouldFilter && matchingSlides.indexOf(slide) === -1;
        });

        if (variant && variant.mediaId) {
          var variantSlide = galleryTrack.querySelector('[data-product-media-id="' + variant.mediaId + '"]');
          if (variantSlide && !variantSlide.hidden) targetSlide = variantSlide;
        }

        if (!targetSlide) targetSlide = shouldFilter ? matchingSlides[0] : slides[0];

        window.requestAnimationFrame(function () {
          productGallery.dispatchEvent(
            new CustomEvent('product:gallery-filtered', {
              detail: {
                targetSlide: targetSlide,
              },
            })
          );
        });
      }

      function syncPicker() {
        picker.querySelectorAll('[data-product-option-group]').forEach(function (group) {
          var groupIndex = Number(group.dataset.optionPosition) - 1;
          var current = group.querySelector('[data-option-current]');
          if (current) current.textContent = selectedOptions[groupIndex] || '';

          group.querySelectorAll('[data-product-option-value]').forEach(function (button) {
            var value = button.dataset.optionValue;
            var isSelected = selectedOptions[groupIndex] === value;
            var isAvailable = hasAvailableVariant(groupIndex, value, group);

            button.setAttribute('aria-pressed', String(isSelected));
            button.disabled = !isAvailable;
            button.classList.toggle('product-option__value--unavailable', !isAvailable);
          });
        });

        var selectedVariant = findVariant(selectedOptions);
        if (!selectedVariant) return;

        variantInput.value = selectedVariant.id;
        filterGalleryByColor(selectedVariant);

        var pixelItem = form.closest('[data-product-pixel-item]');
        if (pixelItem) {
          pixelItem.dataset.productVariantId = selectedVariant.id;
          if (selectedVariant.price !== undefined) pixelItem.dataset.productPrice = selectedVariant.price;
        }

        if (submit) {
          submit.disabled = !selectedVariant.available;
          if ('value' in submit && submit.tagName !== 'BUTTON') {
            submit.value = selectedVariant.available ? availableText : 'Sold out';
          } else {
            submit.textContent = selectedVariant.available ? availableText : 'Sold out';
          }
        }
      }

      picker.addEventListener('click', function (event) {
        var button = event.target.closest('[data-product-option-value]');
        if (!button || button.disabled) return;

        var optionIndex = Number(button.dataset.optionPosition) - 1;
        selectedOptions[optionIndex] = button.dataset.optionValue;
        selectFallbackVariant(optionIndex);
        syncPicker();
        scrollToVariantMedia(findVariant(selectedOptions));
      });

      syncPicker();
    });
  }

  function initQuickAdd() {
    function closeModal(modal) {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    function openModal(id) {
      var modal = document.getElementById(id);
      if (!modal) return;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var selected = modal.querySelector('[data-product-option-value][aria-pressed="true"], .quick-add-form__option[aria-pressed="true"]');
      var close = modal.querySelector('[data-quick-add-close]');
      (selected || close || modal).focus();
    }

    document.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-quick-add-open]');
      if (openButton) {
        event.preventDefault();
        openModal(openButton.dataset.quickAddOpen);
      }

      if (event.target.closest('[data-quick-add-close]')) {
        closeModal(event.target.closest('[data-quick-add-modal]'));
      }

      var variantButton = event.target.closest('[data-quick-add-variant]');
      if (variantButton) {
        var modal = variantButton.closest('[data-quick-add-modal]');
        var input = modal ? modal.querySelector('[data-quick-add-variant-input]') : null;
        if (input) input.value = variantButton.dataset.quickAddVariant;

        var pixelItem = modal ? modal.querySelector('[data-product-pixel-item]') : null;
        if (pixelItem) {
          pixelItem.dataset.productVariantId = variantButton.dataset.quickAddVariant;
          pixelItem.dataset.productPrice = variantButton.dataset.quickAddPrice || pixelItem.dataset.productPrice;
        }

        modal.querySelectorAll('[data-quick-add-variant]').forEach(function (button) {
          button.setAttribute('aria-pressed', String(button === variantButton));
        });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-quick-add-modal]').forEach(function (modal) {
        closeModal(modal);
      });
    });
  }

  function initVideoSoundToggle() {
    document.querySelectorAll('[data-video-sound-toggle]').forEach(function (button) {
      button.dataset.sound = 'off';
      button.setAttribute('aria-label', 'Turn sound on');
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-video-sound-toggle]');
      if (!button) return;

      var frame = button.closest('.home-video__frame');
      var video = frame ? frame.querySelector('video') : null;
      if (!video) return;

      var shouldUnmute = video.muted || video.defaultMuted;
      video.muted = !shouldUnmute;
      video.defaultMuted = !shouldUnmute;
      video.volume = shouldUnmute ? 1 : 0;
      button.dataset.sound = shouldUnmute ? 'on' : 'off';
      button.setAttribute('aria-label', shouldUnmute ? 'Turn sound off' : 'Turn sound on');

      video.play().catch(function () {});
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenuDrawer();
    initCartDrawer();
    initWishlist();
    initLocalization();
    initCollectionControls();
    initProductPixelEvents();
    initRecentlyViewed();
    initCookieConsent();
    initRecommendations();
    initProductGalleries();
    initProductLightbox();
    initProductOptions();
    initQuickAdd();
    initVideoSoundToggle();
  });
})();
